import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getIncidentDetail } from "./IncidentHelper";
import {
  API,
  fileUpload,
  incidentMethodType,
  incidentTypeOptions,
} from "../../../config";
// import Spin from "../../../components/Spin";
import { Button } from "../../../components/ui/button";
import CustomLabelText from "../../../components/CustomLabelText";
import { Label } from "../../../components/ui/label";
import Spin from "../../../components/Spin";
import UserSelect from "../../../components/UserSelect";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import moment from "moment";
import {
  formatSubcontractorName,
  getModuleNamingBySlug,
  MaxLimit,
} from "../../../lib/Misc";
import { Loader2 } from "lucide-react";
import SearchSelect from "../../../components/SearchSelect";
import { DateInputPicker } from "../../../components/DateInputPicker";
import { NumericFormat } from "react-number-format";
import { cn } from "../../../lib/utils";
import { Textarea } from "../../../components/ui/textarea";
import VendorSelect from "../../../components/VendorSelect";
import ContactSelect from "../../../components/ContactSelect";
import MultiFileUpload from "../../../components/MultiFileUpload";
import TrustSelect from "../../../components/TrustSelect";
import { AddIncidentSchema } from "../../../lib/Validation";

const AddEditIncident = ({
  edit,
  incidentID,
  toggleShowAddEditIncident,
  editByIncident = false,
  fetchIncidents,
}) => {
  const { id } = useParams();
  const [incidentData, setIncidentData] = useState();
  const [files, setFiles] = useState();

  const { organizationData } = useOrganization();

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const contactTypeOption = [
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      )}`,
      value: 1,
    },
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      )}`,
      value: 2,
    },
  ];

  const incidentId = incidentID ? incidentID : id;
  // const formValues = useRef();

  const transactionType = [
    { label: "Credit", value: "1" },
    { label: "Debit", value: "0" },
  ];

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getIncidentDetail(incidentId);
      setFiles(data?.files);
      setIncidentData(data);
      setLoading(false);
    } catch (e) {
      setIncidentData(null);
    }
  }

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentId]);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.business_name
          ? item?.business_name
          : item?.first_name
            ? item?.first_name + " " + item?.last_name
            : item?.last_name,
      }));
      setTrustListing(
        trustTempListing?.filter((item) => item.value !== "new") || [],
      );
    } else {
      setTrustListing([]);
    }
  }, [trustList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.amount = Number(`${value?.amount}`.replace(/,/g, ""));

    if (files?.length > 0) {
      for (let fileIndex = 0; fileIndex < files?.length; fileIndex++) {
        if (files[fileIndex]?.id) {
          formData.append(`file_ids[${fileIndex}]`, files[fileIndex]?.id);
        }
        formData.append(
          `files[${fileIndex}]`,
          files[fileIndex]?.url
            ? files[fileIndex]?.url
            : files[fileIndex]?.file,
        );
      }
    }
    formData.append(
      "incident_type",
      value?.incident_type ? value?.incident_type : "",
    );
    formData.append("trust_id", value?.trust_id ? value?.trust_id : "");
    formData.append(
      "contactable_id",
      value?.contactable_id ? value?.contactable_id : "",
    );
    formData.append(
      "contactable_type",
      value?.contactable_type ? value?.contactable_type : "",
    );

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );
    formData.append(
      "verified_by_id",
      value?.verified_by_id ? value?.verified_by_id : "",
    );

    formData.append("amount", value?.amount ? value?.amount : "");

    formData.append(
      "transaction_type",
      value?.transaction_type ? value?.transaction_type : "",
    );

    formData.append(
      "transaction_date",
      value?.transaction_date
        ? moment(value?.transaction_date)?.format("DD-MM-YYYY")
        : "",
    );
    formData.append(
      "verification_date",
      value?.verification_date
        ? moment(value?.verification_date)?.format("DD-MM-YYYY")
        : "",
    );

    formData.append(
      "review_date",
      value?.review_date
        ? moment(value?.review_date)?.format("DD-MM-YYYY")
        : "",
    );

    formData.append(
      "review_by_id",
      value?.review_by_id ? value?.review_by_id : "",
    );

    formData.append("method", value?.method ? value?.method : "");
    formData.append(
      "series_of_events",
      value?.series_of_events ? value?.series_of_events : "",
    );
    formData.append(
      "source_of_customer_wealth",
      value?.source_of_customer_wealth ? value?.source_of_customer_wealth : "",
    );

    formData.append(
      "source_of_customer_funds",
      value?.source_of_customer_funds ? value?.source_of_customer_funds : "",
    );

    formData.append("note", value?.note ? value?.note : "");

    if (incidentId) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.INCIDENT_ADD}${incidentId ? `/${incidentId}` : ""}`,
        formData,
      );
      setLoading(false);
      if (data) {
        editByIncident &&
          localStorage.setItem(
            "BusinessName",
            value?.business_name ? value?.business_name : "",
          );
        toggleShowAddEditIncident();
        fetchIncidents && fetchIncidents();
      }
      return data?.data;
    } catch (error) {
      setIncidentData(value);
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        incident_type: incidentData?.incident_type
          ? incidentData?.incident_type
          : "",
        trust_id: incidentData?.trust_id ? incidentData?.trust_id : "",
        contactable_id: incidentData?.contactable_id,
        contactable_type:
          incidentData?.contactable_type === "vendor"
            ? 1
            : incidentData?.contactable_type === "contact"
              ? 2
              : "",
        verification_date: incidentData?.verification_date
          ? moment(incidentData?.verification_date, "DD-MM-YYYY")
          : "",
        verified_by_id: incidentData?.verified_by_id
          ? incidentData?.verified_by_id
          : "",

        review_date: incidentData?.review_date
          ? moment(incidentData?.review_date, "DD-MM-YYYY")
          : "",
        review_by_id: incidentData?.review_by_id
          ? incidentData?.review_by_id
          : "",
        transaction_date: incidentData?.transaction_date
          ? moment(incidentData?.transaction_date, "DD-MM-YYYY")
          : "",

        method: incidentData?.method ? incidentData?.method : "",

        amount: incidentData?.amount ? incidentData?.amount : "",
        transaction_type: incidentData?.transaction_type
          ? incidentData?.transaction_type
          : "",
        series_of_events: incidentData?.series_of_events
          ? incidentData?.series_of_events
          : "",
        source_of_customer_wealth: incidentData?.source_of_customer_wealth
          ? incidentData?.source_of_customer_wealth
          : "",
        source_of_customer_funds: incidentData?.source_of_customer_funds
          ? incidentData?.source_of_customer_funds
          : "",
        note: incidentData?.note ? incidentData?.note : "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddIncidentSchema(organizationData)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
        setTouched,
        validateField,
      }) => (
        <>
          {loading && <Spin expand={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-4 border rounded-lg">
              <div className="grid gap-4">
                <div className="grid grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="incident_type">
                          <CustomLabelText
                            required={true}
                            labelText="Incident Type"
                            errorField={errors?.incident_type}
                            bottomAlign={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={incidentTypeOptions}
                            optionType={"Incident Type"}
                            handleSelect={(e) => {
                              setFieldValue("incident_type", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.incident_type &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.incident_type}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="trust_id">
                          <CustomLabelText
                            required={false}
                            labelText="Trust"
                            errorField={errors?.trust_id}
                            bottomAlign={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <TrustSelect
                            orgId={organizationData?.organizationId}
                            frameworkData={trustListing} // List of vendors
                            optionType="Trust"
                            handleBlur={handleBlur}
                            handleSelect={(e) => {
                              setFieldValue("trust_id", e);
                              setFieldValue("contactable_id", "");
                              setFieldValue("contactable_type", "");

                              setVendorListing([]);
                              setVendorList([]);

                              setContactList([]);
                              setContactListing([]);
                            }}
                            name="trust_id"
                            disabled={
                              organizationData?.organizationId ? false : true
                            }
                            initialValue={
                              values?.trust_id ? values?.trust_id : ""
                            }
                            setTrustList={setTrustList} // Update vendor list as new data loads
                            setTrustLoading={setTrustLoading} // Control loading state
                            onClear={() => {
                              setFieldValue("trust_id", "");
                              setFieldValue("contactable_id", "");
                              setFieldValue("contactable_type", "");

                              setVendorListing([]);
                              setVendorList([]);

                              setContactList([]);
                              setContactListing([]);
                            }}
                            loading={trustLoading}
                          />
                          {trustLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="contactable_type">
                        <CustomLabelText
                          required={true}
                          labelText="Contact Type"
                          errorField={errors?.contactable_type}
                          bottomAlign={true}
                        />
                      </Label>
                      <div className="relative">
                        <SearchSelect
                          frameworks={contactTypeOption}
                          optionType={"Contact Type"}
                          handleSelect={(e) => {
                            setFieldValue("contactable_type", e);
                            setFieldValue("contactable_id", "");
                            setTimeout(() => {
                              setTouched({ contactable_type: true });
                              validateField("contactable_type");
                            }, 0);

                            setTimeout(() => {
                              setTouched({ contactable_id: true });
                              validateField("contactable_id");
                            }, 0);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.base_type &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.contactable_type}
                        />
                      </div>
                    </div>

                    {values?.contactable_type === 1 ? (
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="contactable_id">
                            <CustomLabelText
                              labelText={getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "vendors",
                                "Vendor",
                              )}
                              errorField={errors?.contactable_id}
                              required={true}
                            />
                          </Label>
                          <div className="relative mt-2">
                            <VendorSelect
                              organizationId={
                                organizationData?.organizationId
                                  ? organizationData?.organizationId
                                  : ""
                              }
                              trustId={values?.trust_id ? values?.trust_id : ""}
                              amlctfContact={values?.trust_id ? false : true}
                              frameworkData={vendorListing} // List of vendors
                              optionType={getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "vendors",
                                "Vendor",
                              )}
                              handleSelect={(e) => {
                                setFieldValue("contactable_id", e);
                              }}
                              name="contactable_id"
                              disabled={false}
                              initialValue={
                                values?.contactable_id
                                  ? values?.contactable_id
                                  : ""
                              }
                              setVendorList={setVendorList} // Update vendor list as new data loads
                              setVendorLoading={setVendorLoading} // Control loading state
                              onClear={() => {
                                setFieldValue("contactable_id", "");
                              }}
                              loading={vendorLoading}
                              className={
                                errors?.contactable_id &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                            {vendorLoading && (
                              <span className="absolute top-2 right-2 animate-spin">
                                <Loader2 width={20} height={20} />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : values?.contactable_type === 2 ? (
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="contactable_id">
                            <CustomLabelText
                              labelText={`${getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "contacts",
                                "Customer",
                              )}`}
                              errorField={errors?.contactable_id}
                              required={true}
                            />
                          </Label>
                          <div className="relative mt-2">
                            <ContactSelect
                              organizationId={
                                organizationData?.organizationId
                                  ? organizationData?.organizationId
                                  : ""
                              }
                              trustId={values?.trust_id ? values?.trust_id : ""}
                              amlctfContact={values?.trust_id ? false : true}
                              frameworkData={contactListing} // List of vendors
                              optionType={`${getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "contacts",
                                "Customer",
                              )}`}
                              handleSelect={(e) => {
                                setFieldValue(`contactable_id`, e);
                              }}
                              name="contactable_id"
                              disabled={false}
                              initialValue={
                                values?.contactable_id
                                  ? values?.contactable_id
                                  : ""
                              }
                              setContactList={setContactList} // Update vendor list as new data loads
                              setContactLoading={setContactLoading} // Control loading state
                              onClear={() => {
                                setFieldValue(`contactable_id`, "");
                              }}
                              className={
                                errors?.contactable_id &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              loading={contactLoading}
                            />
                            {contactLoading && (
                              <span className="absolute top-2 right-2 animate-spin">
                                <Loader2 width={20} height={20} />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {/* <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="verification_date">
                          <CustomLabelText
                            required={true}
                            labelText="Verification Date"
                            errorField={errors?.verification_date}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <DateInputPicker
                            date={
                              values?.verification_date
                                ? values?.verification_date
                                : ""
                            }
                            onSelect={(e) => {
                              setFieldValue("verification_date", e);
                            }}
                            inputClassName="w-full"
                            className={""}
                            disabledDate={{ after: new Date() }}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* Verified By */}
                    {/* <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="verified_by_id">
                          <CustomLabelText
                            required={true}
                            labelText="Verified By"
                            errorField={errors?.verified_by_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <UserSelect
                            orgId={organizationData?.organizationId}
                            frameworkData={userListing} // List of vendors
                            optionType="User"
                            handleSelect={(e) => {
                              setFieldValue(`verified_by_id`, e);
                            }}
                            name="verified_by_id"
                            disabled={false}
                            initialValue={
                              values?.verified_by_id
                                ? values?.verified_by_id
                                : ""
                            }
                            setUserList={setUserList}
                            setUserLoading={setUserLoading}
                            onClear={() => {
                              setFieldValue(`verified_by_id`, "");
                            }}
                            compliance={true}
                            className={
                              errors?.verified_by_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={userLoading}
                          />
                          {userLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div> */}

                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="review_date">
                          <CustomLabelText
                            required={false}
                            labelText="Review Date"
                            errorField={errors?.review_date}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <DateInputPicker
                            date={
                              values?.review_date ? values?.review_date : ""
                            }
                            onSelect={(e) => {
                              setFieldValue("review_date", e);
                            }}
                            inputClassName="w-full"
                            className={""}
                            disabledDate={{ after: new Date() }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Review By */}
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="review_by_id">
                          <CustomLabelText
                            required={false}
                            labelText="Review By"
                            errorField={errors?.review_by_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <UserSelect
                            orgId={organizationData?.organizationId}
                            frameworkData={userListing} // List of vendors
                            optionType="User"
                            handleSelect={(e) => {
                              setFieldValue(`review_by_id`, e);
                            }}
                            name="review_by_id"
                            disabled={false}
                            initialValue={
                              values?.review_by_id ? values?.review_by_id : ""
                            }
                            setUserList={setUserList}
                            setUserLoading={setUserLoading}
                            onClear={() => {
                              setFieldValue(`review_by_id`, "");
                            }}
                            compliance={true}
                            senior_manager={true}
                            className={
                              errors?.review_by_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={userLoading}
                          />
                          {userLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="transaction_date">
                          <CustomLabelText
                            required={false}
                            labelText="Transaction/Incident Date"
                            errorField={errors?.transaction_date}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <DateInputPicker
                            date={
                              values?.transaction_date
                                ? values?.transaction_date
                                : ""
                            }
                            onSelect={(e) => {
                              setFieldValue("transaction_date", e);
                            }}
                            inputClassName="w-full"
                            className={""}
                            disabledDate={{ after: new Date() }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="method">
                          <CustomLabelText
                            required={false}
                            labelText="Method"
                            errorField={errors?.method}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={incidentMethodType}
                            optionType={"Method"}
                            handleSelect={(e) => {
                              setFieldValue("method", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.method &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.method}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="transaction_type">
                          <CustomLabelText
                            required={false}
                            labelText="Transaction Type"
                            errorField={errors?.transaction_type}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={transactionType}
                            optionType={"Transaction Type"}
                            handleSelect={(e) => {
                              setFieldValue("transaction_type", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.transaction_type &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.transaction_type}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <Label htmlFor="amount">
                        <CustomLabelText
                          required={false}
                          labelText="Amount in AUD"
                          errorField={errors?.amount}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name="amount"
                        value={values?.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.amount
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )
                        }
                      />
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="series_of_events">
                      <CustomLabelText
                        required={false}
                        labelText="Incident / Series of Events"
                        errorField={errors?.series_of_events}
                      />
                    </Label>
                    <Textarea
                      id="series_of_events"
                      name="series_of_events"
                      value={
                        values?.series_of_events ? values?.series_of_events : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.series_of_events &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="source_of_customer_wealth">
                      <CustomLabelText
                        required={false}
                        labelText="Source of the Customer Wealth"
                        errorField={errors?.source_of_customer_wealth}
                      />
                    </Label>
                    <Textarea
                      id="source_of_customer_wealth"
                      name="source_of_customer_wealth"
                      value={
                        values?.source_of_customer_wealth
                          ? values?.source_of_customer_wealth
                          : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.source_of_customer_wealth &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="source_of_customer_funds">
                      <CustomLabelText
                        required={false}
                        labelText="Source of the Customer Funds"
                        errorField={errors?.source_of_customer_funds}
                      />
                    </Label>
                    <Textarea
                      id="source_of_customer_funds"
                      name="source_of_customer_funds"
                      value={
                        values?.source_of_customer_funds
                          ? values?.source_of_customer_funds
                          : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.source_of_customer_funds &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="note">
                      <CustomLabelText
                        required={false}
                        labelText="Note for Austrac"
                        errorField={errors?.note}
                      />
                    </Label>
                    <Textarea
                      id="note"
                      name="note"
                      value={values?.note ? values?.note : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.note &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="files">
                      <CustomLabelText
                        required={false}
                        labelText="Documents"
                        errorField={errors?.note}
                      />
                    </Label>
                    <MultiFileUpload files={files} setFiles={setFiles} />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditIncident();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditIncident;
